import { WorkflowInstanceStateType } from '../components/WorkflowInstanceState/types';

const STATE_LABELS: Record<WorkflowInstanceStateType, string> = {
  draft: 'Draft',
  active: 'Active',
  live: 'Live',
  ended: 'Ended',
  archived: 'Archived',
  convertToRollout: 'Convert to rollout',
  convertToStaticConfig: 'Convert to static config',
};

export const getStateLabel = (value: unknown): string => {
  if (typeof value === 'string') {
    return STATE_LABELS[value as WorkflowInstanceStateType] ?? value;
  }
  return 'Unknown';
};

export const getActionTitle = (
  oldState: unknown,
  newState: unknown,
  workflowLabel: string,
): string => {
  const newStr = typeof newState === 'string' ? newState : '';

  switch (newStr) {
    case 'active':
    case 'live':
      return `Launched ${workflowLabel}`;
    case 'ended':
      return `Ended ${workflowLabel}`;
    case 'archived':
      return 'Archived';
    default:
      return `Changed state from ${getStateLabel(oldState)} to ${getStateLabel(newState)}`;
  }
};
